import { useEffect } from "react";
import { SITE_URL } from "./env";

export interface SeoMeta {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  noIndex?: boolean;
}

/** Update document.title and meta tags imperatively (no react-helmet dependency). */
export function useSeo(meta: SeoMeta) {
  useEffect(() => {
    document.title = meta.title;
    setMeta("description", meta.description);
    setMeta("og:title", meta.title, "property");
    setMeta("og:description", meta.description, "property");
    setMeta("og:url", `${SITE_URL}${meta.path}`, "property");
    setMeta("og:type", "website", "property");
    setMeta(
      "og:image",
      meta.ogImage ?? `${SITE_URL}/og-image.svg`,
      "property"
    );
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.description);
    setMeta(
      "twitter:image",
      meta.ogImage ?? `${SITE_URL}/og-image.svg`
    );
    setLink("canonical", `${SITE_URL}${meta.path}`);
    if (meta.noIndex) {
      setMeta("robots", "noindex");
    } else {
      setMeta("robots", "index, follow");
    }
  }, [meta.title, meta.description, meta.path, meta.ogImage, meta.noIndex]);
}

function setMeta(name: string, value: string, kind: "name" | "property" = "name") {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${kind}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(kind, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}
